import type { ComponentType } from 'react';

const landing4Paths = [
  '/landing4',
  '/landing4/step1',
  '/landing4/step2',
  '/landing4/step3',
  '/landing4/step4',
] as const;

const loadOnboarding = async (): Promise<{
  Component: ComponentType;
}> => {
  const { Onboarding } = await import('./Onboarding/Onboarding');
  return { Component: Onboarding };
};

export const landing4Routes = landing4Paths.map((path) => ({
  path,
  lazy: loadOnboarding,
}));

export const protectedLanding4Routes = [
  {
    path: '/landing4/plan',
    lazy: async () => {
      const { PlanRoute } = await import('./Plan/Plan');
      return { Component: PlanRoute };
    },
  },
];
